import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import baseUrl from '~/services/base';

import { apiPedido, apiSolicitacao, apiResumo, apiConsultaRevendas } from '../services/api';
import TipoPerfil from '../assets/styles/payloadsLancamentoExcel/perfilLancamento.json';

import RevendedoresPayload from '../assets/styles/payloadRevendedoresExcel/payloadRevendedoresExcel.json';

export const PedidoContext = createContext([]);

export function PedidoProvider(props) {
	const { children, user } = props;
	const [notas, setNotas] = useState([]);
	const [pedidos, setPedidos] = useState([]);
	const [montanteLancamento, setMontanteLancamento] = useState(0);

	const [dataResumo, setDataResumo] = useState([]);
	const [dataRevendas, setDataRevendas] = useState([]);
	const [dataSolicitacoes, setDataSolicitacoes] = useState([]);

	const [loadingLancamento, setLoadingLancamento] = useState(false);
	const [loadingRevendedores, setLoadingRevendedores] = useState(false);
	const [destinatarios, setDestinatarios] = useState([]);

	const [totalItemsRevendas, setTotalItemsRevendas] = useState(0);
	const [totalItemsResumo, setTotalItemsResumo] = useState(0);
	const [totalItems, setTotalItems] = useState(0);

	const [loadingResumo, setLoadingResumo] = useState(true);
	const [loadingPedido, setLoadingPedido] = useState(true);
	const [loadingRevenda, setLoadingRevenda] = useState(true);
	const [loadingSolicitacao, setLoadingSolicitacao] = useState(true);

	let callingDestinatarios = false;
	let callingResumo = false;

	async function getResumo(limite, pagina, filtroOrder, filtroPesquisa) {
		if (callingResumo) return null;
		setLoadingResumo(false)
		try {
			callingResumo = true;
			const parametro = {};
			parametro.limite = limite;
			parametro.page = pagina;


			if(filtroOrder.length > 0){
				parametro.order = filtroOrder;
			}

			if(filtroPesquisa.length > 0){
				parametro.nome = filtroPesquisa.trim();
			}

			const resumo = await apiResumo.get(``,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
					params: parametro
				}).then(res => {
					setTotalItemsResumo(res.data.total_registros);
					setDataResumo(res.data)
					setLoadingResumo(true)
					return res
				});
			return resumo;
		} catch (err) {
			setLoadingResumo(true)
		} finally {
			callingResumo = false;
		}
		return true;
	}

	async function getResumoWithResponse(limite, pagina, filtroOrder, filtroPesquisa) {
		setLoadingResumo(false)
		try {
			const parametro = {};
			parametro.limite = limite;
			parametro.page = pagina;


			if(filtroOrder.length > 0){
				parametro.order = filtroOrder;
			}

			if(filtroPesquisa.length > 0){
				parametro.nome = filtroPesquisa.trim();
			}

			const resumo = await apiResumo.get(``,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
					params: parametro
				}).then(res => {
					setTotalItemsResumo(res.data.total_registros);
					setDataResumo(res.data)
					setLoadingResumo(true)
					return res
				});
			return resumo;
		} catch (err) {
			setLoadingResumo(true)
		} 
		return true;
	}

	const callExportResumo = useCallback(
		async (nome) => {
			setLoadingRevendedores(true);
			try {
				const dataPath = '.dados';
				let url = '';
				// Condicional Url
				url = `${baseUrl.resumo}${nome ? `?nome=${nome}` : ''}`;

				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: dataPath,
						url: url,
						headers: {
							Authorization: `Bearer ${user.token.access}`,
						},
						params: {
							items: 15000,
							pagina: 1
						},
					},
					styles: [
						{
							name: "bold",
							bold: true
						},
						{
							name: "date",
							num_format: "DD/MM/YYYY"
						},
						{
							name: "money",
							num_format: "#,##0.00;[RED]-#,##0.00"
						}
					],
					format: RevendedoresPayload,
				};

				download(payload, "ResumoLucree");

			} catch (error) {
				setLoadingRevendedores(false);
			}
		}
	);

	const getExportResumo = (nome = '') =>{
		setLoadingRevendedores(true);
		callExportResumo(nome);
	}

	async function getRevendas(pagina, limite, filtroPesquisa, filtroOrder) {
		setLoadingRevenda(false)
		const consulta = user.dados.cargo.toLowerCase() === 'industria' ? 'consulta-revendas' : `consulta-resumo/${user.dados.documento}`;
		try {
			const revendas = await apiConsultaRevendas.get(consulta, {
				params: {
					page: pagina,
					order: filtroOrder,
					nome: filtroPesquisa,
					items: limite
				},
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token.access}`,
				},
			}).then(res => {
				setTotalItemsRevendas(res.data.total_registros);
				setDataRevendas(res.data.dados);
			})
			return revendas;
		} catch (err) {
			setLoadingRevenda(true)
		}
		return true;
	}

	async function solicitarPedido(body) {
		setLoadingPedido(false)
		try {
			const pedidoSolicitado = await apiPedido
				.post('/pedidos', body, {
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then(() => {
					setLoadingPedido(true)
					toast.success('Pedido Solicitado!')
				})
			return pedidoSolicitado;
		} catch (error) {
			setLoadingPedido(true)
			if (error.message !== 'Request failed with status code 409') {
				toast.error('Ocorreu um problema no envio do pedido.', error);
			}
			return error.message;
		}
	}

	async function getPedidoIndividual(idPedido, tipo) {
		try {
			const pedidoIndividual = await apiPedido.get(
				`/pedidos/${idPedido}?tipo=${tipo}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}
			)
			return pedidoIndividual;
		} catch (error) {
			console.log('errorerror', error)
			toast.error(
				'Pedido não foi carregado. Por favor atualize a página.'
			);
		}
		return true;
	}

	async function getNotas(idPedido) {
		try {
			const notaPedidoReturn = await apiPedido.get(`/pedidos/notas/${idPedido}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then((res) => {
					res.data.result.notas ?
						setNotas(res.data.result.notas.notas) : setNotas([]);

					return res.data.result.notas ? res.data.result.notas.notas : []
				});

			return notaPedidoReturn
		} catch (error) {
			toast.error(
				'As notas não foram carregadas. Por favor atualize a página.'
			);
		}
		return true;
	}

	async function inserirNotas(idPedido, notasFiscais, enviadoNota) {
		const body = {
			status_nota_pedido: enviadoNota,
			notas: notasFiscais
		}
		try {
			const inserido = await apiPedido.post(`/pedidos/notas/${idPedido}`, body,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then(() => {
					getNotas(idPedido)
				});

			if (enviadoNota === 'PENDENTESALVAR') { toast.success('Notas salvas para envio!') }
			if (enviadoNota === 'ENVIADO') { toast.success('Notas enviadas com sucesso!') }
			if (enviadoNota === 'CONCLUIDO') { toast.success('Envio de notas finalizado com sucesso!') }

			return inserido
		} catch (error) {
			toast.error(
				'Notas não inseridas. Por favor atualize a página.'
			);
		}
		return true
	}

	async function getPedidos(limite, pagina, tipo, filtroData, filtroStatus, filtroPesquisa) {
		setLoadingPedido(false)
		const tipoPedido = tipo?.length > 0 ? `&tipo=${tipo}` : '';
		const status = filtroStatus?.length > 0 ? `&status=${filtroStatus}` : '';
		const pesquisa = filtroPesquisa?.length > 0 ? `&busca=${filtroPesquisa.trim()}` : '';
		try {
			const pedidosFunc = await apiPedido.get(
				`/pedidos?limite=${limite}&pagina=${pagina}${tipoPedido}${filtroData}${status}${pesquisa}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}
			);
			if(destinatarios.length <= 0){
				getDestinatarios();
			}
			setTotalItems(pedidosFunc.data.total);
			setPedidos(pedidosFunc.data.pedidos);
			setMontanteLancamento(pedidosFunc?.data?.montante_pedidos || 0.0);
			setLoadingPedido(true)
			return pedidosFunc;

		} catch (err) {
			setLoadingPedido(true)
		}
		return true;
	}

	async function getDestinatarios() {
		if (callingDestinatarios) return;
	
		try {
			callingDestinatarios = true;
			await apiPedido.get('/pedidos/destinatarios', {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token.access}`,
				},
			}).then(res => {
				setDestinatarios(res.data.destinatarios)
			}).catch((error) => {
				console.log(error)
				setDestinatarios([])
			});
		} catch (error) {
			console.log('Erro getDestinatarios')
		} finally {
			callingDestinatarios = false;
		}
	}

	async function aprovarOuReprovarPedido(numPedido, status) {
		try {
			await apiPedido.put(
				`/pedidos/${status}`,
				{
					numero_pedido: numPedido,
				},
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}
			)

		} catch (error) {
			error === 'Saldo insuficiente' ?
				toast.error('Saldo Insuficiente', error)
				:
				toast.error('Ocorreu um problema na aprovação do pedido', error)
		}
	}

	async function getSolicitacoes(limite, pagina, filtroStatus, filtroPesquisa) {
		setLoadingSolicitacao(false)
		const status = filtroStatus.length > 0 ? `&status=${filtroStatus}` : '';
		const pesquisa = filtroPesquisa.length > 0 ? `&nome=${filtroPesquisa.trim()}` : '';
		try {
			const solicitacao = await apiSolicitacao.get(`/solicitacoes?limite=${limite}&pagina=${pagina}${status}${pesquisa}`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token.access}`,
				},
			}).then(res => {
				setDataSolicitacoes(res.data)
				setLoadingSolicitacao(true)
				return res.data;
			})
			return solicitacao;
		} catch (err) {
			setLoadingSolicitacao(true)
		}
		return true
	}

	async function postSolicitacao(idRevenda) {
		try {
			await apiSolicitacao.post(`/solicitacoes`, {
				cliente_id: idRevenda,
			}, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token.access}`,
				},
			})
		} catch (err) {
			console.log('er', err)
		}
	}

	async function getSolicitacoesListaRevenda(limite = 10, pagina = 1) {
		try {
			const solicitacaoLista = await apiSolicitacao.get(
				`/solicitacoes?limite=${limite}&pagina=${pagina}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}
			);
			return solicitacaoLista;

		} catch (err) {
			console.log(err, 'getSolicitacoesListaRevenda')
		}
		return true;
	}

	async function aprovarVisualizarSaldo(solicitacaoId, permitir) {
		setLoadingSolicitacao(false)
		const body = {
			solicitacao_id: parseInt(solicitacaoId, 10),
			permissao: permitir
		}
		try {
			const aprovacao = await apiSolicitacao
				.patch(`/solicitacoes`, body, {
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then((res) => {
					setLoadingSolicitacao(true)
					return res
				})
			return aprovacao;
		} catch (error) {
			setLoadingSolicitacao(false)
			toast.error('Ocorreu um erro', error);
		}
		return true;
	}

	const getExport = useCallback(
		async (tipo, filtroData, status, pesquisa, params) => {
			try {
				const dataPath = '.pedidos';
				let url = '';

				const paramsInfo = {
					tipo: tipo,
					excel: true,
					limite: 15000,
					pagina: 1,
					status: status,
					busca: pesquisa
				}

				if(filtroData){
					paramsInfo.data_lancamento = `${params.dateInit}|${params.dateEnd}`;
				}


				// Condicional Url
				url = `${baseUrl.pgm}/pedidos`;

				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: dataPath,
						url: url,
						headers: {
							Authorization: `Bearer ${user.token.access}`,
						},
						params: paramsInfo,
					},
					styles: [
						{
							name: "bold",
							bold: true
						},
						{
							name: "date",
							num_format: "DD/MM/YYYY"
						},
						{
							name: "money",
							num_format: "#,##0.00;[RED]-#,##0.00"
						}
					],
					format: TipoPerfil, // Acessando dicionário dentro do Json TipoPerfil
				};

				download(payload);
			} catch (error) {
				setLoadingLancamento(false);
				// eslint-disable-next-line no-console
				console.log('Erro no Download Export, extrato.');
			}
		},
		[user.dados.lojista_id, user.dados.tipo_cliente]
	);

	/**
	 * Excel Lancamento
	 */

	function download(data, name = "lancamentosLucree") {
		var oReq = new XMLHttpRequest();
		oReq.open(
			'POST',
			'https://api.grupoe2f.com.br/export/export',
			true
		);
		oReq.responseType = 'blob';
		oReq.setRequestHeader('Content-Type', 'application/json');

		const link = document.createElement('a');

		oReq.onload = function () {
			var blob = oReq.response;
			link.setAttribute('download', `${name}.xlsx`);
			link.href = URL.createObjectURL(blob);
			link.setAttribute('href', URL.createObjectURL(blob));
			document.body.appendChild(link);
			link.click();
			setLoadingRevendedores(false);
			setLoadingLancamento(false);
		};

		oReq.send(JSON.stringify(data));

	}

	return (
		<PedidoContext.Provider
			value={{
				postSolicitacao,
				solicitarPedido,
				aprovarOuReprovarPedido,
				destinatarios,
				notas,
				inserirNotas,
				getNotas,
				getResumo,
				getResumoWithResponse,
				getPedidos,
				getRevendas,
				getSolicitacoes,
				getDestinatarios,
				getPedidoIndividual,
				getSolicitacoesListaRevenda,
				aprovarVisualizarSaldo,
				dataResumo,
				setDataResumo,
				dataRevendas,
				setDataRevendas,
				dataSolicitacoes,
				pedidos,
				montanteLancamento,
				setPedidos,
				totalItems,
				totalItemsResumo,
				totalItemsRevendas,
				setTotalItems,
				setTotalItemsResumo,
				setTotalItemsRevendas,
				loadingPedido,
				setLoadingPedido,
				loadingRevenda,
				setLoadingRevenda,
				loadingResumo,
				setLoadingResumo,
				loadingSolicitacao,
				setLoadingSolicitacao,
				getExport,
				getExportResumo,
				loadingRevendedores,
				setLoadingRevendedores,
				loadingLancamento,
				setLoadingLancamento
			}}>
			{children}
		</PedidoContext.Provider>
	);
}
